import React from 'react';
import './manage-evals-dropdown.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArchive, faChartLine, faLink, faPen, faPrint, faSquareArrowUpRight } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { UseCloudAdminFunction } from '../../../utils/firebase.utils';
import { useState } from 'react';
import { ModalAlert, ModalConfirm } from '../../modal/modal.component';
import { useRef } from 'react';
import { useEffect } from 'react';

const ManageEvalsDropdown = ({
  ev,
  showEvalDropdown,
  setShowEvalDropdown
}) => {

  const [ alertMessage, setAlertMessage ] = useState('');
  const [ confirmMessage, setConfirmMessage ] = useState('');
  const approveRef = useRef(() => {});

  useEffect(() => {
    if (showEvalDropdown) setShowEvalDropdown(null);
  }, [location])

  function copyUrl(id) {
    const url = `${window.location.origin}/${id}`;
    navigator.clipboard.writeText(url);

    const el = document.getElementById(`${id}-tooltip`);
    if (!el) return;

    el.style.visibility = 'visible';
    const timeout = setTimeout(() => {
        document.getElementById(`${id}-tooltip`).style.visibility = 'hidden';
        setShowEvalDropdown(null);
        timeout && clearTimeout(timeout);
    }, 2000);
  }

  function archiveEval(id) {
    console.log('archive', id);
    setConfirmMessage(`Are you sure you want to archive this evaluation? This action can be undone.`);
    approveRef.current = () => {
      continueArchive();
    }

    async function continueArchive() {
      const res = await UseCloudAdminFunction(
        'saveDocToFirestore',
        {
          'path': `evaluations_v2/${id}`,
          'docData': {
            'status'  : 'archived'
          },
          'isUpdate': true
        }
      )
      console.log(res);
      if (res.error) {
        setAlertMessage('Error archiving evaluation. Please try again.');
        return;
      }
    }
  }

  return (
    <div className={`manage-evals-dropdown ${showEvalDropdown === ev.id ? 'active' : ''}`}>
      <div className='manage-evals-dropdown-menu'>
        <div className='g-tooltip'>
          <span
            className='g-tooltip-text'
            id={`${ev.id}-tooltip`}>Copied!
          </span>
          <button
            className='g-button text-only'
            onClick={() => copyUrl(ev.path)}>
            <FontAwesomeIcon icon={faLink} />
            <span>Copy Link</span>
          </button>
        </div>
        <Link to={`/${ev.path}`} target="_blank">
          <button 
            className='g-button text-only'
            onClick={() => setShowEvalDropdown(null)}>
            <FontAwesomeIcon icon={faSquareArrowUpRight} />
            <span>Open Eval</span>
          </button>

        </Link>
        <Link to={`/admin/evals/${ev.path}/data`}>
          <button className='g-button text-only'>
            <FontAwesomeIcon icon={faChartLine} />
            <span>Data</span>
          </button>
        </Link>
        <Link to={`/admin/evals/${ev.path}/edit`} >
          <button className='g-button text-only'>
            <FontAwesomeIcon icon={faPen} />
            <span>Edit</span>
          </button>
        </Link>
        <button
          className='g-button text-only'
          onClick={() => archiveEval(ev.id)}>
          <FontAwesomeIcon icon={faArchive} />
          <span>Archive</span>
        </button>
        {/* <Link
          className={`disabled ` +
            !ev.cpdu || ev.hours === 0 ? 'disabled' : ''
          }
          to={`/admin/evals/${ev.path}/printeoc`}>
          <button className={`g-button text-only`}>
            <FontAwesomeIcon icon={faPrint} />
            <span>Print EOC</span>
          </button>
        </Link> */}
      </div>
      <ModalAlert
        show={!!alertMessage}
        cancel={() => setAlertMessage('')}
        message={alertMessage} />
      <ModalConfirm
        show={!!confirmMessage}
        cancel={() => setConfirmMessage('')}
        message={confirmMessage}
        onApprove={approveRef.current} />
    </div>
  )
}

export default ManageEvalsDropdown